export enum AVRouteEnum {
  AV = 'AV',
  MANAGEMENT = 'AVManagement',
  SOURCES = 'AVSources',
  PRODUCTION_CENTERS = 'AVProductionCenters',
  PARENT_BROADCASTERS = 'AVParentBroadcasters',
  BROADCASTERS = 'AVBroadcasters',
  SCHEDULE_RECORDINGS = 'AVScheduleRecordings',
  RECORDINGS = 'AVRecordings',
  PROGRAMS = 'AVPrograms',
  ENRICHMENTS = 'AVEnrichments',
  FEATURED_PEOPLE = 'AVFeaturedPeople',
  LOGOS = 'AVLogos',
  AUDIENCES = 'AVAudiences',
  AUDIENCE_CHANNEL_SOURCES = 'AVAudienceChannelSources',
  AUDIENCES_LIST = 'AVAudiencesList',
  ECONOMIC_VALUE = 'AVEconomicValue',
  ECONOMIC_VALUE_CHANNEL_SOURCES = 'AVEconomicValueChannelSources',
  ECONOMIC_VALUE_UPLOAD = 'AVEconomicValueUpload',
  CNMC_REPORTS = 'AVCnmcReports',
  SUPPORTS = 'AVSupports',
}
